import {AfterDateValidator, BaseDateValidator, BeforeDateValidator} from './validator';

export {DateDirective} from './directive';
export {DatePipe} from './pipe';
export {ExtraDateControlValidators} from './validator';

export const DATE_VALIDATORS = [BaseDateValidator, AfterDateValidator, BeforeDateValidator];
